import { Recurso } from "lib.common/dist/CleanArch";
import { EstadisticasCRMDtSource } from "../../bussines/dataSources/EstadisticasCRMDtSource";
import { EstadisticasCRMRepository } from "../../bussines/repositories/EstadisticasCRMRepository";
import { FechaParams } from "../../utils/params/FechaParams.params";
import { ClientesSinContactoModel } from "../models/ClientesSinContactoModel";
import { EstadisticasCRMModel } from "../models/EstadisticasCRMModel";
import { EstadoProductosAnualModel } from "../models/EstadoProductosAnualModel";
import { ResumenAtencionModel } from "../models/ResumenAtencionModel";
import { ErrDevValidacion } from "lib.common/dist/errorHandler";

export class EstadisticasCMRRepositoryImpl implements EstadisticasCRMRepository<EstadisticasCRMModel, ClientesSinContactoModel, ResumenAtencionModel, EstadoProductosAnualModel> {
    private dataSource: EstadisticasCRMDtSource;

    constructor(dataSource: EstadisticasCRMDtSource) {
        this.dataSource = dataSource;
    }

    async getEstadisticasCRM(input: FechaParams): Promise<Recurso<EstadisticasCRMModel>> {
        try {
            const result = await this.dataSource.getEstadisticasCRM(input);

            if (result.isSuccess()) {
                return Recurso.fromData<EstadisticasCRMModel>(
                    EstadisticasCRMModel.deserialize(result.data!)
                );
            }
            return Recurso.fromError<EstadisticasCRMModel>(result.error!);
        } catch (error) {
            return Recurso.fromError<EstadisticasCRMModel>(
                new ErrDevValidacion(error as Error)
            );
        }
    }

    async getClientesSinContacto(input: FechaParams): Promise<Recurso<ClientesSinContactoModel[]>> {
        try {
            const result = await this.dataSource.getClientesSinContacto(input);

            if (result.isSuccess()) {
                return Recurso.fromData<ClientesSinContactoModel[]>(
                    result.data!.map(ClientesSinContactoModel.deserialize)
                );
            }
            return Recurso.fromError<ClientesSinContactoModel[]>(result.error!);
        } catch (error) {
            return Recurso.fromError<ClientesSinContactoModel[]>(
                new ErrDevValidacion(error as Error)
            );
        }
    }

    async getResumenAtenciones(input: FechaParams): Promise<Recurso<ResumenAtencionModel[]>> {
        try {
            const result = await this.dataSource.getResumenAtenciones(input);

            if (result.isSuccess()) {
                return Recurso.fromData<ResumenAtencionModel[]>(
                    result.data!.map(ResumenAtencionModel.deserialize)
                );
            }
            return Recurso.fromError<ResumenAtencionModel[]>(result.error!)
        } catch (error) {
            return Recurso.fromError<ResumenAtencionModel[]>(
                new ErrDevValidacion(error as Error)
            );
        }
    }

    async getProductosEstadoAnual(input: FechaParams): Promise<Recurso<EstadoProductosAnualModel[]>> {
        try {
            const result = await this.dataSource.getProductosEstadoAnual(input);
            if (result.isSuccess()) {
                return Recurso.fromData<EstadoProductosAnualModel[]>(
                    result.data!.map(EstadoProductosAnualModel.deserialize)
                );
            }
            return Recurso.fromError<EstadoProductosAnualModel[]>(result.error!);
        } catch (error) {
            return Recurso.fromError<EstadoProductosAnualModel[]>(
                new ErrDevValidacion(error as Error)
            );
        }
    }

}